import PropTypes from "prop-types";

import { Icon } from "../../../components/BaseComponents/Icon";

export const PhoneCallIcon = ({ signalColor = "currentColor", ...props }) => (
	<Icon viewBox="0 0 32 32" fill="none" {...props}>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="m18.5183 19.4813-2.3356 2.3008a18.9915 18.9915 0 0 1-3.3731-2.592 19.2086 19.2086 0 0 1-2.5909-3.3709l2.3018-2.3357a1.0015 1.0015 0 0 0 .2062-1.0909L10.3278 6.793a1.0013 1.0013 0 0 0-1.176-.5727L4.751 7.382a1.0025 1.0025 0 0 0-.7506 1.0025 21.164 21.164 0 0 0 5.9891 13.6277 21.1638 21.1638 0 0 0 13.632 5.9879 1.0002 1.0002 0 0 0 1.0003-.7505l1.1629-4.4029a1.0003 1.0003 0 0 0-.5716-1.176l-5.5953-2.3978a1.0005 1.0005 0 0 0-1.0996.2083v0Z"
		/>
		<path
			stroke={signalColor}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M18.1819 4a9.8183 9.8183 0 0 1 9.8182 9.8182"
		/>
		<path
			stroke={signalColor}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M18.1819 8.3643a5.4544 5.4544 0 0 1 5.4545 5.4545"
		/>
	</Icon>
);

PhoneCallIcon.propTypes = {
	signalColor: PropTypes.string,
};
